import React, { useState, useEffect } from "react";
import "./verification.css";
import logo from "../../../assets/images/logo.png";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";

function Verification({ token }) {
  const navigate = useNavigate();

  const { verification_secret } = useParams();
  const [message, setMessage] = useState("Verifying email...");
  const [subText, setSubText] = useState(
    "Once verified, your booking will be activated.",
  );

  const activateBooking = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/athlete/${verification_secret}`, {},
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const message = response.data.split(" || ");
      
      setMessage(message[0] || "Your booking is now confirmed!");
      setSubText(
        message[1] || "Email has been successfully verified. You may now close this window. Thank you!",
      );
    } catch (error) {
      const messages = error.response?.data?.split(" || ") || [];

      setMessage(messages[0] || "Verification failed!");
      setSubText(
        messages[1] || "Please try again later, or call us directly to book.",
      );
    }
  };

  useEffect(() => {
    if (!verification_secret) {
      navigate("/");
    } else if (token) {
      activateBooking();
    }
  }, [verification_secret, navigate, token]);

  return (
    <div className="verification-page">
      <div className="verification-nav">
        <div className="verification-logo">
          <img
            className="verification-logo-img"
            src={logo}
            alt="Hymus Sports"
          />
        </div>
      </div>

      <div className="verification-container">
        <img className="verification-img" src={logo} alt="Hymus Logo" />
        <h2 className="verification-title">{message}</h2>
        <p className="verification-txt">{subText}</p>
      </div>
    </div>
  );
}

export default Verification;
